import React from 'react';
import { Box, Typography, Paper, Grid, Button, Avatar } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHandsHelping, faChartPie, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { useHistory } from 'react-router-dom';

export default function HelpLandingView() {
    const history = useHistory();

    return (
        <Box sx={{ maxWidth: 1000, mx: 'auto', mt: { xs: 4, md: 8 }, mb: 8, px: { xs: 3, md: 4 } }}>
            
            {/* Cabecera Imponente y Minimalista */}
            <Box sx={{ mb: { xs: 6, md: 8 }, textAlign: 'center' }}>
                <Typography 
                    variant="h2" 
                    sx={{ 
                        fontWeight: 900, 
                        color: '#0a0a0a', 
                        letterSpacing: '-0.04em',
                        fontSize: { xs: '2.5rem', md: '3.5rem' },
                        mb: 2,
                        lineHeight: 1.1
                    }}
                >
                    Centro de Acopio Playa Mansa
                </Typography>
                
                <Typography 
                    variant="subtitle1" 
                    sx={{ 
                        color: '#d32f2f', 
                        fontWeight: 800, 
                        mb: 3,
                        textTransform: 'uppercase',
                        letterSpacing: '0.1em',
                        fontSize: '0.85rem'
                    }}
                >
                    Atención de Emergencia • Respuesta Activa
                </Typography>
                
                <Typography 
                    variant="body1" 
                    sx={{ 
                        color: '#555', 
                        maxWidth: 650, 
                        mx: 'auto',
                        fontSize: { xs: '1rem', md: '1.1rem' },
                        lineHeight: 1.6
                    }}
                >
                    Estamos trabajando para canalizar la ayuda necesaria a los afectados. 
                    Tu registro es fundamental para organizar la logística y asegurar que los recursos lleguen a quienes más lo necesitan en la ciudad.
                </Typography>
            </Box>

            {/* Quitamos el alignItems="stretch" de aquí */}
            <Grid container spacing={4}>
                
                {/* Tarjeta: Solicitar Ayuda */}
                {/* Agregamos display: 'flex' al item para que la tarjeta se estire correctamente */}
                <Grid item xs={12} md={6} sx={{ display: 'flex' }}>
                    <Paper 
                        elevation={0} 
                        sx={{ 
                            p: { xs: 4, md: 5 }, 
                            borderRadius: 5, 
                            border: '1px solid #eaeaea', 
                            width: '100%', // Cambiamos height por width
                            display: 'flex', 
                            flexDirection: 'column', 
                            justifyContent: 'space-between',
                            transition: 'all 0.3s ease',
                            '&:hover': {
                                transform: 'translateY(-6px)',
                                borderColor: '#1565c0',
                                boxShadow: '0 20px 40px -15px rgba(21,101,192,0.15)'
                            }
                        }}
                    >
                        <Box>
                            <Avatar sx={{ width: 64, height: 64, bgcolor: '#f0f4f8', color: '#1565c0', mb: 3 }}>
                                <FontAwesomeIcon icon={faHandsHelping} size="lg" />
                            </Avatar>
                            <Typography variant="h4" sx={{ fontWeight: 800, mb: 2, letterSpacing: '-0.02em', color: '#0a0a0a' }}>
                                Solicitar Ayuda
                            </Typography>
                            <Typography variant="body1" sx={{ color: '#666', mb: 4, lineHeight: 1.7 }}>
                                Estamos aquí para apoyarte. Realiza un registro si necesitas ayuda directamente 
                                <strong style={{ color: '#111' }}> para ti</strong> o si deseas reportar una situación de vulnerabilidad 
                                <strong style={{ color: '#111' }}> para un tercero</strong>.
                            </Typography>
                        </Box>
                        <Button 
                            variant="contained" 
                            fullWidth 
                            endIcon={<FontAwesomeIcon icon={faArrowRight} />}
                            sx={{ 
                                py: 2, 
                                bgcolor: '#1565c0', 
                                color: '#fff', 
                                fontWeight: 700, 
                                borderRadius: 3,
                                textTransform: 'none',
                                fontSize: '1rem',
                                boxShadow: 'none',
                                mt: 2, // Margen superior para empujar el botón
                                '&:hover': { bgcolor: '#0d47a1', boxShadow: 'none' }
                            }} 
                            onClick={() => history.push('/sos-solicitud')}
                        >
                            Solicitar Ayuda
                        </Button>
                    </Paper>
                </Grid>

                {/* Tarjeta: Transparencia */}
                <Grid item xs={12} md={6} sx={{ display: 'flex' }}>
                    <Paper 
                        elevation={0} 
                        sx={{ 
                            p: { xs: 4, md: 5 }, 
                            borderRadius: 5, 
                            border: '1px solid #eaeaea', 
                            width: '100%', // Cambiamos height por width
                            display: 'flex', 
                            flexDirection: 'column', 
                            justifyContent: 'space-between',
                            transition: 'all 0.3s ease',
                            '&:hover': {
                                transform: 'translateY(-6px)',
                                borderColor: '#2e7d32',
                                boxShadow: '0 20px 40px -15px rgba(46,125,50,0.15)'
                            }
                        }}
                    >
                        <Box>
                            <Avatar sx={{ width: 64, height: 64, bgcolor: '#edf7ed', color: '#2e7d32', mb: 3 }}>
                                <FontAwesomeIcon icon={faChartPie} size="lg" />
                            </Avatar>
                            <Typography variant="h4" sx={{ fontWeight: 800, mb: 2, letterSpacing: '-0.02em', color: '#0a0a0a' }}>
                                Transparencia
                            </Typography>
                            <Typography variant="body1" sx={{ color: '#666', mb: 4, lineHeight: 1.7 }}>
                                Auditoría en tiempo real. Consulta el estado de las entregas, despachos vehiculares y el inventario operativo. Todo nuestro movimiento es público.
                            </Typography>
                        </Box>
                        <Button 
                            variant="contained" 
                            fullWidth 
                            endIcon={<FontAwesomeIcon icon={faArrowRight} />}
                            sx={{ 
                                py: 2, 
                                bgcolor: '#2e7d32', 
                                color: '#fff', 
                                fontWeight: 700, 
                                borderRadius: 3,
                                textTransform: 'none',
                                fontSize: '1rem',
                                boxShadow: 'none',
                                mt: 2, // Margen superior para empujar el botón
                                '&:hover': { bgcolor: '#1b5e20', boxShadow: 'none' }
                            }} 
                            onClick={() => history.push('/sos-transparencia')}
                        >
                            Ver Reportes
                        </Button>
                    </Paper>
                </Grid>
            </Grid>
        </Box>
    );
}